import { Component, OnDestroy, OnInit } from '@angular/core';
import {
    FEATURE_CURRENCY,
    FEATURE_GENERIC_TASKS,
    PersonsOrganisationDto,
    UserService,
    hasAnyPermission,
    hasFeatureFlag
} from '@flyfreely-portal-ui/flyfreely';
import { WorkspaceStateService } from '@flyfreely-portal-ui/workspace';
import {
    collapseOnLeaveAnimation,
    expandOnEnterAnimation
} from 'angular-animations';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { WidgetRegistrationWithSection } from '../../../outstanding-tasks-view.service';

const PILOT_REGISTER_STATUSES_IDENTIFIER = 'pilotRegisterStatusesWidget';

/**
 * Displays the current user's personnel register statuses for the current
 * workspace organisation, using the personnel-registers-status component.
 */
@Component({
    selector: 'pilot-register-statuses-widget',
    templateUrl: './pilot-register-statuses-widget.component.html',
    animations: [expandOnEnterAnimation(), collapseOnLeaveAnimation()]
})
export class PilotRegisterStatusesWidget implements OnInit, OnDestroy {
    organisation: PersonsOrganisationDto;
    showBody = true;

    personId: number;
    canAdminOrganisation: boolean;
    hasCurrency: boolean;
    readonly canEdit = false;

    private ngUnsubscribe$ = new Subject<void>();

    constructor(
        private workspaceStateService: WorkspaceStateService,
        private userService: UserService
    ) {}

    ngOnInit() {
        this.workspaceStateService.currentLoadedOrganisation$
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(loaded => {
                this.organisation = loaded.organisation;
                this.personId = this.userService.getCurrentUser()?.id;
                this.canAdminOrganisation = hasAnyPermission(
                    this.organisation,
                    PersonsOrganisationDto.Permissions.ORGANISATION_EDIT
                );
                this.hasCurrency = hasFeatureFlag(
                    this.organisation,
                    FEATURE_CURRENCY
                );
            });
    }

    ngOnDestroy() {
        this.ngUnsubscribe$.next();
        this.ngUnsubscribe$.complete();
    }
}

export const pilotRegisterStatusesWidgetRegistration: WidgetRegistrationWithSection =
    {
        widgetIdentifier: PILOT_REGISTER_STATUSES_IDENTIFIER,
        section: 'profile',
        component: PilotRegisterStatusesWidget,
        isAvailable: organisation =>
            hasFeatureFlag(organisation, FEATURE_GENERIC_TASKS),
        requiredPermissions: [
            PersonsOrganisationDto.Permissions.ORGANISATION_VIEW
        ]
    };
